// @flow
import { createDevTools } from 'redux-devtools';
import DockMonitor from 'redux-devtools-dock-monitor';
import LogMonitor from 'redux-devtools-log-monitor';
import * as React from 'react';

export default createDevTools(
    <DockMonitor changePositionKey="Q" defaultIsVisible={false} toggleVisibilityKey="H">
        <LogMonitor />
    </DockMonitor>
);



// WEBPACK FOOTER //
// ./src/drivers/dev-tools.js